/**
 * Route constants for the application.
 * Routes are defined using TanStack Router's file-based routing in the /pages directory.
 *
 * !IMPORTANT! The titles of the routes will be translated with the t() on the Navbar component. Please do not translate them here.
 */
export const APP_ROUTES = {
    ROOT: "/",
    SESSIONS: "/sessions",
    PROFILE: "/profile",
    SETTINGS: "/settings",
    CLINICS: "/clinics",
    STAFF: "/staff",
    SHIFTS: "/shifts",
    TREATMENTS: "/treatments",
} as const;

export type RouterPaths = (typeof APP_ROUTES)[keyof typeof APP_ROUTES] | string;
